<template>
  <div
    @mouseenter="isHoveredInternal = true"
    @mouseleave="isHoveredInternal = false"
  >
    <slot v-bind:isHovered="isHovered" v-bind:isTouch="isTouch"></slot>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  data() {
    return {
      isHoveredInternal: false,
      isTouch: !window.matchMedia('(hover: hover)').matches,
    }
  },
  computed: {
    isHovered() {
      return !this.isTouch && this.isHoveredInternal
    },
  },
}
</script>